import { render } from "./ClaimNoteItem.vue?vue&type=template&id=0a65bba7&scoped=true&bindings={}"
import script from "./ClaimNoteItem.vue?vue&type=script&lang=ts"
export * from "./ClaimNoteItem.vue?vue&type=script&lang=ts"

import "./ClaimNoteItem.vue?vue&type=style&index=0&id=0a65bba7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a65bba7"

export default script